import * as Sentry from '@sentry/react'

import { APP_BUILD_ID } from './build-id'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined

export function initSentry(): void {
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: environment ?? 'development',
    // Build identity (rootcause FIX C): every event carries the bundle's
    // commit SHA, both as the SDK release and as a plain queryable tag.
    // Without this, the 2026-07-13 M02 fan-out investigation could not
    // determine which bundle the reporting device ran (the stale-bundle
    // hypothesis had to be killed via prod id forensics instead). The
    // `client_build` tag duplicates the release on purpose — tag search
    // and release search have different ergonomics in Sentry, and the tag
    // survives even if release-based grouping is ever reconfigured.
    release: `citycare-frontend@${APP_BUILD_ID}`,
    initialScope: { tags: { client_build: APP_BUILD_ID } },
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
  })
}
